export const LOCAL_DRAFT_DEBOUNCE_MS = 1000;
export const SERVER_DRAFT_DEBOUNCE_MS = 5000;
